<div class="root-div">
  <p-popover #blueprintInfoPopover appendTo="body" styleClass="blueprint-info-popover">
    <div class="blueprint-popover-text">{{ blueprintTooltip }}</div>
  </p-popover>

  <div class="title-group" (click)="onBlueprintInfoClick($event, blueprintInfoPopover)">
    <span [pTooltip]="isTitleTruncated() ? fullWorkspaceTitle : ''" tooltipPosition="top" [escape]="false">
      {{ workspaceTitle }}
    </span>
    @if (workspaceTitle && workspaceTitle.trim() !== '') {
    <span class="workspace-count">
      <p-chip class="custom-chip" label="{{ nodesNumCount }}"> </p-chip>
    </span>
    }
  </div>
</div>
